import DAO from './DAO';
import OfflineQueue from './queue/OfflineQueue';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import Metadata from '../helpers/metadata/Metadata';
import dataModel from '../models/DataModel';
import closeoutsService from '../services/closeoutsService';
import projectTemplatesService from '../services/projectTemplatesService';

export default class CloseoutsDAO extends DAO {
  constructor(store) {
    super(store, 'closeout');
    this.OfflineQueue = OfflineQueue;
    this.clearCloseouts = this.clearCloseouts.bind(this);
  }

  clearCloseouts() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  unsetCloseout(closeoutId) {
    StoreItemProcessing.deleteItemInStore(this.itemType, closeoutId);
  }

  /**
  * @param  {number} closeoutId - closeout record identifier
  */
  async getCloseout(closeoutId, options) {
    return this._getItem(closeoutId, closeoutsService.getCloseout.bind(this, closeoutId, options), options);
  }

  async getCloseoutSnapShot(closeoutableType, closeoutable_id) {
    if (!this.closeout_templates) {
      this.closeout_templates = await projectTemplatesService.getProjectTemplateCloseouts();
    }
    return closeoutsService.getCloseoutSnapShot({
      closeoutable_type: closeoutableType,
      closeoutable_id: closeoutable_id,
      company_closeout_template_id: this.closeout_templates ? this.closeout_templates[0].id : null,
    });
  }

  /**
  * @param  {number} closeoutId - closeout record identifier
  * @returns {object<Promise<string>>} result - "offline", "error", "success"
  */
  deleteCloseout(closeoutId, options, eventMetadatum) {
    let closeout = this.findItem(closeoutId);
    if (closeout) {
      this.unsetCloseout(closeoutId);
    }

    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }

    if (dataModel.isOffline) {
      this.OfflineQueue.addQueueItem(this.itemType, 'delete', { closeoutId, eventMetadatum });
      this.throwItemError();
    } 
    else {    
      return closeoutsService.deleteCloseout(closeoutId, closeout.project_id, eventMetadatum).then(response => {
        if (response.error && !response.offline) {
          dataModel.displayHTTPError('Deleting a closeout', response.error, false);
          if (closeout) {
            StoreItemProcessing.setItemInStore(this.itemType, StoreItemProcessing.normalizeItem(closeout));
          }
          this.throwItemError();
        }
        else if (response.offline) {
          this.OfflineQueue.addQueueItem(this.itemType, 'delete', { closeoutId, eventMetadatum });
          this.throwItemError();
        }
        else {
          dataModel.displayInfoErrorMessage('The closeout was successfully deleted.', 4000, 1);
          return this.mapToReturn(closeout, options);
        } 
      });
    }
  }

  completeOfflineUpdate(queueItem) {
    const eventMetadatum = queueItem.itemInfo.eventMetadatum;
    const options = queueItem.itemInfo.options;
    switch (queueItem.operationKey) {
    case 'delete':
      return this.deleteCloseout(queueItem.itemInfo.closeoutId, options, eventMetadatum);
    default:
      break;
    }
  }

  handleActionCableAndGetRequest(acData) {
    const closeoutId = acData.closeout_id;
    const closeout = this.findItem(closeoutId);
    if (closeout) {
      this.markNeedsSync(closeout);
    }
    switch (acData.type) {
    case 'newCloseout':
    case 'updateCloseout':
      return this.getCloseout.bind(this);
    default:
    }
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_closeouts, options.toIgnore.closeouts, this.unsetCloseout, this.clearCloseouts, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/CloseoutsDAO.js